import { CompactEncrypt, importJWK, JWK } from 'jose';

export async function encrypt(value: string, key: JWK): Promise<string> {
	const encoder = new TextEncoder();
	const data = encoder.encode(value);
	const cryptoKey = await importJWK(key, 'ECDH-ES');
	return await new CompactEncrypt(data).setProtectedHeader({ alg: 'ECDH-ES', enc: 'A256GCM' }).encrypt(cryptoKey);
}
